import { createAction } from 'redux-actions'

export const SET_DARK_MODE = 'APP.SET_DARK_MODE'
export const SET_LIGHT_MODE = 'APP.SET_LIGHT_MODE'
export const SET_DOWNLOAD_BANNER_SIZE = 'APP.SET_DOWNLOAD_BANNER_SIZE'
export const SET_DOWNLOAD_BANNER_VISIBILITY = 'APP.SET_DOWNLOAD_BANNER_VISIBILITY'

export const setDarkMode = createAction(SET_DARK_MODE)
export const setLightMode = createAction(SET_LIGHT_MODE)
export const setDownloadBannerSize = createAction(SET_DOWNLOAD_BANNER_SIZE)
export const setDownloadBannerVisibility = createAction(SET_DOWNLOAD_BANNER_VISIBILITY)
